import { CarpayPaymentFlow } from '@customTypes/carpayPaymentFlow.interface'
import { createContext } from 'react'

interface CarpayPaymentFlowContextType {
    state: CarpayPaymentFlow
    updateState: (newState: Partial<CarpayPaymentFlow>) => void
}

const CarpayPaymentFlowContext = createContext<CarpayPaymentFlowContextType | undefined>(undefined)

export default CarpayPaymentFlowContext
